import React from 'react';
import SectionLoading from '../../common/SectionLoading';
import SectionLoadingError from '../../common/SectionLoadingError';
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";

export default class PrescriptionLastActivity extends React.Component {
    render() {
        const { containerClass, rxHistory, waitingOnRxHistory, rxHistoryError } = this.props;
        return (
            <div className={containerClass}>
                <div className="subsection-heading">Last Activity</div>
                {waitingOnRxHistory === true
                    ? <SectionLoading />
                    : rxHistoryError
                        ? <SectionLoadingError message={rxHistoryError.status === 404 ?
                            "Prescription doesn't exist." : "We're not able to display the prescription details. Please try again later."}
                          />
                        : <React.Fragment>
                            {
                                rxHistory && rxHistory.length > 0 &&
                                <React.Fragment>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="rx-activity">
                                            <div className="row">
                                                <div className="col-3 rx-activity__column-headings">PICKED UP ON</div>
                                                <div className="col-5 rx-activity__column-headings">PHARMACY</div>
                                                <div className="col-2 rx-activity__column-headings">INSURANCE</div>
                                                <div className="col-2 rx-activity__column-headings">LAST PAID</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {rxHistory.map((item, index) =>
                                        (<div key={index}>
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="rx-activity__info">
                                                    <div className="row">
                                                            <div className="col-12 col-md-3">{item.PickUpDate ? item.PickUpDate : 'Not Available'}</div>
                                                            <div className="col-12 col-md-5">{item.PharmacyName}</div>
                                                            <div className="col-12 col-md-2">{item.InuranceName}</div>
                                                            <div className="col-12 col-md-2">${item.Cost}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>)
                                    )}
                                </React.Fragment>
                            }
                        </React.Fragment>
                }
            </div>
        );
    }
}